
  <mat-card>
        <div>Please enter all the relevent numbers for this equation</div>
        <mat-card-content >
          <mat-grid-list cols="6" [rowHeight]="35">
          <!-- <mat-grid-list cols="6" [rowHeight]="50"> -->
            <mat-grid-tile> H.I - InflectionPoint </mat-grid-tile>
            <mat-grid-tile>  <input [(ngModel)]="inflectionCalMethod.Hi_InflectionPoint" type="number"   placeholder="0" required  ngDefaultControl ></mat-grid-tile>
            <mat-grid-tile> H.I - Slope 1 </mat-grid-tile>
            <mat-grid-tile>  <input [(ngModel)]="inflectionCalMethod.Hi_Slope1" type="number"  placeholder="0" required  ngDefaultControl > </mat-grid-tile>            
            <mat-grid-tile> H.I - Intercept 1 </mat-grid-tile>
            <mat-grid-tile>  <input [(ngModel)]="inflectionCalMethod.Hi_Intercept1" type="number"  placeholder="0" required ngDefaultControl > </mat-grid-tile>
          </mat-grid-list>
        </mat-card-content>        
      </mat-card>
      <mat-card>        
          <mat-card-content >
              <mat-grid-list cols="6" [rowHeight]="35">
            <!-- <mat-grid-list cols="6" [rowHeight]="50"> -->
              <mat-grid-tile> H.I - Slope 2  </mat-grid-tile>
              <mat-grid-tile>  <input [(ngModel)]="inflectionCalMethod.Hi_Slope2" type="number"   placeholder="0" required ngDefaultControl > </mat-grid-tile>
              <mat-grid-tile> H.I - Intercept 2 </mat-grid-tile>
              <mat-grid-tile>  <input [(ngModel)]="inflectionCalMethod.Hi_Intercept2" type="number"  placeholder="0" required ngDefaultControl > </mat-grid-tile>            
              <mat-grid-tile> M.I - InflectionPoint </mat-grid-tile>
              <mat-grid-tile>  <input [(ngModel)]="inflectionCalMethod.Mi_InflectionPoint" type="number"  placeholder="0" required ngDefaultControl > </mat-grid-tile>
            </mat-grid-list>
          </mat-card-content>
          
        </mat-card>
        <mat-card>          
            <mat-card-content>
                <mat-grid-list cols="6" [rowHeight]="35">
              <!-- <mat-grid-list cols="6" [rowHeight]="50"> -->
                <mat-grid-tile> M.I - Slope 1 </mat-grid-tile>
                <mat-grid-tile>  <input [(ngModel)]="inflectionCalMethod.Mi_Slope1" type="number"   placeholder="0" required ngDefaultControl > </mat-grid-tile>
                <mat-grid-tile> M.I - Intercept 1 </mat-grid-tile>
                <mat-grid-tile>  <input [(ngModel)]="inflectionCalMethod.Mi_Intercept1" type="number"   placeholder="0" required ngDefaultControl > </mat-grid-tile>            
                <mat-grid-tile> M.I - Slope 2 </mat-grid-tile>
                <mat-grid-tile>  <input [(ngModel)]="inflectionCalMethod.Mi_Slope2" type="number"  placeholder="0" required ngDefaultControl > </mat-grid-tile>
              </mat-grid-list>
            </mat-card-content>            
          </mat-card>


          <mat-card>          
              <mat-card-content>
                  <mat-grid-list cols="6" [rowHeight]="35">
                <!-- <mat-grid-list cols="6" [rowHeight]="50"> -->
                  <mat-grid-tile>  M.I - Intercept 2</mat-grid-tile>
                  <mat-grid-tile>  <input [(ngModel)]="inflectionCalMethod.Mi_Intercept2" type="number"   placeholder="0" required ngDefaultControl > </mat-grid-tile>
                  <mat-grid-tile>  Adjust base </mat-grid-tile>
                  <mat-grid-tile>  <input [(ngModel)]="inflectionCalMethod.Adjust_base" type="number"   placeholder="0" required ngDefaultControl > </mat-grid-tile>            
                  <mat-grid-tile> Slope </mat-grid-tile>
                  <mat-grid-tile>  <input [(ngModel)]="inflectionCalMethod.Slope" type="number"  placeholder="0" required ngDefaultControl > </mat-grid-tile>
                </mat-grid-list>
              </mat-card-content>            
            </mat-card>